import { OTA_Customer } from "./ota_customer.model";
import { OTA_VehSegmentCore } from "./ota_vehsegmentcore.model";
import { OTA_VehSegmentInfo } from "./ota_vehsegmentinfo.model";

export class OTA_VehReservation {
    public reservationStatus: string;
    public customer = new OTA_Customer();
    public vehSegmentCore = new OTA_VehSegmentCore();
    public vehSegmentInfo = new OTA_VehSegmentInfo();
}